import { render, staticRenderFns } from "./Page503.vue?vue&type=template&id=c983448c"
import script from "./Page503.vue?vue&type=script&lang=js"
export * from "./Page503.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports